import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DebugService } from '../../../../services/debug.service';
import { InsightsTags } from '@marketing/insights/insights.interface';

@Component({
  selector: 'ft-insights-tags',
  templateUrl: './insights-tags.component.html',
  styleUrls: ['./insights-tags.component.scss'],
})
export class InsightsTagsComponent implements OnInit, OnDestroy {
  @Input() insightsTags: InsightsTags;
  isDebugMode: boolean;
  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private debugService: DebugService) {}

  ngOnInit(): void {
    this.debugService
      .isShowInsightsData$()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((isShowInsightsData: boolean) => {
        this.isDebugMode = isShowInsightsData;
      });
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
